import { initialize } from './initialize';
import { preload } from './preloading';
import { loadTheme } from './theme';

export const boot = async (signal?: AbortSignal) => {
    await loadTheme(signal);
    await Promise.all([preload(signal), initialize(signal)]);
};
